// import { useRecipes, WrapperModalRecipes } from modules/recipes";
import { useFormContext } from "react-hook-form";
import { DataRecipe } from "../../../../redux/@types";
import { useSelector } from "react-redux";
import { Button, Col, message, Typography } from "antd";

import {
  selectRecipeForUpdate,
  selectIsUpdateRecipe,
  selectModalRecipes,
  RecipesChangeModalState,
} from "../../../../redux";
import { InputSelect, InputText, InputHTML } from "../inputs";
import Upload from "../inputs/Upload";
import { PATH_S3_BUCKET } from "../../../utils/constants";
import { useEffect, useState } from "react";
import { useRecipes, WrapperModalRecipes } from "../../../../modules/recipes";
import useAppDispatch from "../../../../redux/hooks/useAppDispatch";
import { recipesCategoriesService } from "../../../services";

const { Title } = Typography;

export const ModalRecipes = () => {
  const modalRecipes = useSelector(selectModalRecipes);
  const isUpdateRecipe = useSelector(selectIsUpdateRecipe);
  const updateRecipe = useSelector(selectRecipeForUpdate);

  const dispatch = useAppDispatch();

  const { isLoading, onSubmitCreateOrUpdate } = useRecipes();

  const { control, handleSubmit, setValue, watch, reset } =
    useFormContext<DataRecipe>();
  const pathCover = watch("path_cover");
  const [categories, setCategories] = useState<any[]>([]);

  useEffect(() => {
    recipesCategoriesService
      .find({ query: { $sort: { name: 1 }, $limit: 100 } })
      .then((res: any) => setCategories(res.data))
      .catch((err: any) => {
        message.error(err.message);
      });
  }, []);

  return (
    <WrapperModalRecipes
      title={
        isUpdateRecipe
          ? `Actualizando receta: '${updateRecipe?.id!}'`
          : `Creando receta`
      }
      open={modalRecipes}
      width={"620px"}
      destroyOnClose
      onClose={() => {
        reset({});
        dispatch(RecipesChangeModalState(false));
      }}
    >
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Nombre:
        </Title>
        <InputText
          placeHolder="Nombre de la receta"
          name="name"
          control={control}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Categoría:
        </Title>
        <InputSelect
          showSearch
          name="category_id"
          control={control}
          dataOptions={categories.map((item: any) => ({
            value: String(item.id),
            title: item.name,
          }))}
          label="Categoría"
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Descripción corta:
        </Title>
        <InputText
          placeHolder="Breve descripción"
          name="short_description"
          control={control}
          rows
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Descripción larga:
        </Title>
        <InputText
          placeHolder="Descripción detallada"
          name="description"
          control={control}
          rows
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Ingredientes:
        </Title>
        <InputHTML
          placeHolder="Ingredientes en HTML"
          name="html_ingredients"
          control={control}
          isUpdating={isUpdateRecipe && !!watch("html_ingredients")}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Pasos:
        </Title>
        <InputHTML
          placeHolder="Pasos en HTML"
          name="html_steps"
          control={control}
          isUpdating={isUpdateRecipe && !!watch("html_steps")}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Imagen de portada:
        </Title>
        {pathCover ? (
          <img
            src={`${PATH_S3_BUCKET}/${pathCover}`}
            alt="path_cover"
            style={{
              marginBottom: "7px",
              width: "100%",
              height: "100%",
              maxWidth: "250px",
              maxHeight: "250px",
            }}
          />
        ) : null}
        <Upload
          filePath="recipes"
          onUploadedFile={(files) => {
            const file = files[0] || files;
            setValue("path_cover", file.fileKey);
            message.success("Imagen subida correctamente");
          }}
          value={pathCover}
          placeHolder="Cargar imagen de portada"
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Estado:
        </Title>
        <InputSelect
          name="status"
          control={control}
          dataOptions={[
            { title: "Activo", value: "active" },
            { title: "Inactivo", value: "inactive" },
          ]}
          label="Estado"
        />
      </Col>
      <Button
        style={{ width: "100%", marginTop: 10 }}
        type="primary"
        shape="round"
        size="large"
        onClick={handleSubmit(onSubmitCreateOrUpdate)}
        loading={isLoading}
      >
        {isUpdateRecipe ? "Actualizar receta" : "Crear receta"}
      </Button>
    </WrapperModalRecipes>
  );
};
